import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AstroDots from "@/pages/AstroDots";
import AstroDotsPrivacy from "@/pages/AstroDotsPrivacy";
import AstroDotsTerms from "@/pages/AstroDotsTerms";
import InkNMotionPrivacy from "@/pages/InkNMotionPrivacy";
import InkNMotionSupport from "@/pages/InkNMotionSupport";
import InkNMotionPrivacyFull from "@/pages/InkNMotionPrivacyFull";
import InkNMotionTerms from "@/pages/InkNMotionTerms";
import YesChefPrivacy from "@/pages/YesChefPrivacy";
import YesChefTerms from "@/pages/YesChefTerms";
import YesChefSupport from "@/pages/YesChefSupport";
import YesChefPrivacyPolicy from "@/pages/YesChefPrivacyPolicy";
import YesChefTermsOfUse from "@/pages/YesChefTermsOfUse";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/astrodots" element={<AstroDots />} />
          <Route path="/astrodots/privacy" element={<AstroDotsPrivacy />} />
          <Route path="/astrodots/terms" element={<AstroDotsTerms />} />
          <Route path="/ink-n-motion/privacy" element={<InkNMotionPrivacy />} />
          <Route path="/inknmotion" element={<InkNMotionSupport />} />
          <Route path="/inknmotion/privacy" element={<InkNMotionPrivacyFull />} />
          <Route path="/inknmotion/terms" element={<InkNMotionTerms />} />
          <Route path="/yes-chef/privacy" element={<YesChefPrivacy />} />
          <Route path="/yes-chef/terms" element={<YesChefTerms />} />
          <Route path="/yes-chef/support" element={<YesChefSupport />} />
          <Route path="/yes-chef/privacy-policy" element={<YesChefPrivacyPolicy />} />
          <Route path="/yes-chef/terms-of-use" element={<YesChefTermsOfUse />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
